import Vue from "vue";
import toast from "../component/toast.vue";
import "./loading.scss";

const CONTAINER_ID = 'loading_container'

export default {
    show(options = null) {
        this.hide();

        const container = document.querySelector(CONTAINER_ID) || document.createElement('div');
        container.id = CONTAINER_ID;
        document.documentElement.append(container);

        let text = '';
        if (options && options.content && options?.content.length > 0) {
            text = `<div>${options.content}</div>`;
        }

        return new Promise((resolve => {
            const vm = new Vue({
                render: h => h(toast, {
                    props: {
                        content: `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>${text}`,
                        stayTime: -1,
                        withMask: false
                    },
                    on: {
                        close() {
                            vm.$destroy();
                            global.loading_instance = null;
                            resolve();
                        }
                    }
                })
            }).$mount(container);
            global.loading_instance = vm;
        }))
    },
    hide() {
        const target = global.loading_instance;
        if (target) {
            const wrapper = target.$el
            target.$destroy();
            if (wrapper) {
                wrapper.remove();
            }
        }
        global.loading_instance = null;
    }
}